import { METHOD_TYPES } from "../../../stateCommon/consts";
const getTipsCode = ({
  msgKeyPath = 'result.body.message'
} = {}) => `
  $tips.error({
    content: ${msgKeyPath}
  })
`;
const getProdListCode = () => `
  async () => {
    const prodListParams = {
       filter:source.prodFilter || [],
       page:source.prodPage || 1,
       size:source.prodSize || 20
    }
    const result = await source.$requests.prodList({query:prodListParams})
    await source.$methods.prodCount()
    if (result.body.code === 0) {
      source.prodListData = result.body.data;
    } else {
      ${getTipsCode()}
    }
    return result
  }
 `;
export const generateProdListMethod = options => ({
  id: 'prodList',
  title: '获取正式表列表',
  code: getProdListCode(),
  autoCatch: true,
  loading: true,
  debugCode: `
    const result = await invokeCurrentMethod();console.log(result);
    `,
  type: METHOD_TYPES.code
});
const getListWithStatusCode = () => `
async () => {
  const listParams = {
     filter:source.filter,
     page:source.page,
     size:source.size,
     sort: source.sort.map(item => item.k).join(','),
     order: source.sort.map(item => item.o).join(',')
  }
  const listApiMap = {
    0: {
        list: 'list',
        count: 'count'
    },
    1: {
        list: 'publishedList',
        count: 'publishedCount',
    },
    2: {
        list: 'unpublishedList',
        count: 'unpublishedCount',
    }
  }

  const currentListApi = listApiMap[source.publishStatusFilter || 0].list
  const currentCountApi = listApiMap[source.publishStatusFilter || 0].count

  const listDataResult = await source.$requests[currentListApi]({query: listParams})
  const { body } = await source.$requests[currentCountApi]({ query: {filter: listParams.filter} });
  if (body.code === 0) {
    source.total = body.data.total;
  } else {
    return false
  }
  if(listDataResult.body.code !== 0) {
  ${getTipsCode({
  msgKeyPath: 'listDataResult.body.message'
})}
    return false
  }
  const list = listDataResult.body.data
  const ids = list.map(item => item._id)
  const statusResult = await source.$requests.getPublishStatus({body:{ids}})
  if(statusResult.body.code === 0) {
    const publishStatus = statusResult.body.data
    const listDataWithStatus = list.map((item, index) => {
      return {_rv_status:publishStatus[index].status,...item}
    })
    source.listDataWithStatus = listDataWithStatus
    return listDataWithStatus

  } else {
  ${getTipsCode({
  msgKeyPath: 'statusResult.body.message'
})}
  }

}
`;
export const generateListWithStatusMethod = options => ({
  id: 'listWithStatus',
  title: '获取带状态的原表列表',
  code: getListWithStatusCode(),
  autoCatch: true,
  loading: true,
  debugCode: `
    const listDataWithStatus = await invokeCurrentMethod();console.log(listDataWithStatus);
    `,
  type: METHOD_TYPES.code
});
const getPublishCode = () => `
  async (id,desc) => {
    const result = await source.$requests.publish({body:{desc}, query:{id}})
    if (result.body.code !== 0) {
      ${getTipsCode()}
    }
    return result
  }
 `;
export const generatePublishMethod = options => ({
  id: 'publish',
  title: '发布',
  code: getPublishCode(),
  autoCatch: true,
  loading: true,
  debugCode: `
    const result = await invokeCurrentMethod();console.log(result);
    `,
  type: METHOD_TYPES.code,
  args: [{
    id: 'id',
    title: '发布的数据ID'
  }, {
    id: 'desc',
    title: '发布描述'
  }],
  meta: {
    cgi: 'publish',
    tpl: 'list.publish'
  }
});
const getDeleteOpListCode = () => `
  async () => {
    const listParams = {
       page:source.deleteOpPage || 1,
       size:source.deleteOpSize || 20
    }
    const result = await source.$requests.deleteOpList({query:listParams})
    await source.$methods.deleteOpCount()
    if (result.body.code === 0) {
      source.deleteOpListData = result.body.data
    } else {
      ${getTipsCode()}
    }
    return result
  }
 `;
export const generateDeleteOpListMethod = options => ({
  id: 'deleteOpList',
  title: '获取删除记录',
  code: getDeleteOpListCode(),
  autoCatch: true,
  loading: true,
  debugCode: `
    const result = await invokeCurrentMethod();console.log(result);
    `,
  type: METHOD_TYPES.code,
  meta: {
    cgi: 'deleteOpList',
    tpl: 'list.deleteOpList'
  }
});
const getDeleteOpCountCode = () => `
  async () => {
    const listParams = {
       filter:source.deleteOpFilter,
    }
    const result = await source.$requests.deleteOpCount({query:listParams})
    if (result.body.code === 0) {
      source.deleteOpCount = result.body.data.total
    } else {
      ${getTipsCode()}
    }
    return result
  }
 `;
export const generateDeleteOpCountMethod = options => ({
  id: 'deleteOpCount',
  title: '获取删除记录总数',
  code: getDeleteOpCountCode(),
  autoCatch: true,
  loading: true,
  debugCode: `
    const result = await invokeCurrentMethod();console.log(result);
    `,
  type: METHOD_TYPES.code,
  meta: {
    cgi: 'deleteOpCount',
    tpl: 'list.deleteOpCount'
  }
});
const getPublishDeleteOpCode = () => `
  async (actionId,desc) => {
    const result = await source.$requests.publishDeleteOp({body:{actionId, desc}})
     if (result.body.code !== 0) {
        ${getTipsCode()}
      }
    return result
  }
 `;
export const generatePublishDeleteOpMethod = options => ({
  id: 'publishDeleteOp',
  title: '发布删除',
  code: getPublishDeleteOpCode(),
  autoCatch: true,
  loading: true,
  debugCode: `
    const result = await invokeCurrentMethod();console.log(result);
    `,
  type: METHOD_TYPES.code,
  args: [{
    id: 'actionId',
    title: '操作ID'
  }, {
    id: 'desc',
    title: '发布描述'
  }],
  meta: {
    cgi: 'publishDeleteOp',
    tpl: 'list.publishDeleteOp'
  }
});
const getHistoryListCode = () => `
  async (id = props.id) => {
   const listParams = {
       filter:source.historyFilter || [],
       page:source.historyPage || 1,
       size:source.historySize || 20
    }
    const result = await source.$requests.historyList({query: {id,...listParams}})
    await source.$methods.historyCount()
     if (result.body.code !== 0) {
       ${getTipsCode()}
      } else {
         source.historyListData = result.body.data
      }
    return result
  }
 `;
export const generateHistoryListMethod = options => ({
  id: 'historyList',
  title: '获取历史版本',
  code: getHistoryListCode(),
  autoCatch: true,
  loading: true,
  debugCode: `
    const result = await invokeCurrentMethod();console.log(result);
    `,
  type: METHOD_TYPES.code,
  args: [{
    id: 'id',
    title: '数据ID'
  }],
  meta: {
    cgi: 'historyList',
    tpl: 'list.historyList'
  }
});
const getHistoryCountCode = () => `
  async (id = props.id) => {
   const listParams = {
       filter:source.historyCount,
    }
    const result = await source.$requests.historyCount({query: {id,...listParams}})
     if (result.body.code !== 0) {
       ${getTipsCode()}
      } else {
         source.historyCount = result.body.data.total
      }
    return result
  }
 `;
export const generateHistoryCountMethod = options => ({
  id: 'historyCount',
  title: '获取历史版本总数',
  code: getHistoryCountCode(),
  autoCatch: true,
  loading: true,
  debugCode: `
    const result = await invokeCurrentMethod();console.log(result);
    `,
  type: METHOD_TYPES.code,
  args: [{
    id: 'id',
    title: '数据ID'
  }],
  meta: {
    cgi: 'historyCount',
    tpl: 'list.historyCount'
  }
});
const getRollbackCode = () => `
  async (versionId) => {
    const result = await source.$requests.rollback({body: {versionId}})
     if (result.body.code !== 0) {
       ${getTipsCode()}
      }
    return result
  }
 `;
export const generateRollbackMethod = options => ({
  id: 'rollback',
  title: '回滚',
  code: getRollbackCode(),
  autoCatch: true,
  loading: true,
  debugCode: `
    const result = await invokeCurrentMethod();console.log(result);
    `,
  type: METHOD_TYPES.code,
  args: [{
    id: 'versionId',
    title: '版本ID'
  }],
  meta: {
    cgi: 'rollback',
    tpl: 'list.rollback'
  }
});
const getUnpublishedListCode = () => `
  async () => {
    const listParams = {
       // filter:[],
       // page:0,
       // size:20
    }
    const result = await source.$requests.unpublishedList({query: listParams})
     if (result.body.code === 0) {
      source.unpublishedListData = result.body.data
    } else {
      ${getTipsCode()}
    }
    return result
  }
 `;
export const generateUnpublishedListMethod = options => ({
  id: 'unpublishedList',
  title: '获取未发布的列表',
  code: getUnpublishedListCode(),
  autoCatch: true,
  loading: true,
  debugCode: `
    const result = await invokeCurrentMethod();console.log(result);
    `,
  type: METHOD_TYPES.code,
  meta: {
    cgi: 'unpublishedList',
    tpl: 'list.unpublishedList'
  }
});
const getPublishedListCode = () => `
  async () => {
    const listParams = {
       // filter:[],
       // page:0,
       // size:20
    }
    const result = await source.$requests.publishedList({query: listParams})
     if (result.body.code === 0) {
      source.publishedListData = result.body.data
    } else {
      ${getTipsCode()}
    }
    return result
  }
 `;
export const generatePublishedListMethod = options => ({
  id: 'publishedList',
  title: '获取已发布的列表',
  code: getPublishedListCode(),
  autoCatch: true,
  loading: true,
  debugCode: `
    const result = await invokeCurrentMethod();console.log(result);
    `,
  type: METHOD_TYPES.code,
  meta: {
    cgi: 'publishedList',
    tpl: 'list.publishedList'
  }
});
const getPublishedCountCode = () => `
  async () => {
    const listParams = {
       filter:source.publishedFilter,
    }
    const result = await source.$requests.publishedCount({query: listParams})
     if (result.body.code === 0) {
      source.publishedCount = result.body.data.total
    } else {
      ${getTipsCode()}
    }
    return result
  }
 `;
export const generatePublishedCountMethod = options => ({
  id: 'publishedCount',
  title: '获取已发布总数',
  code: getPublishedCountCode(),
  autoCatch: true,
  loading: true,
  debugCode: `
    const result = await invokeCurrentMethod();console.log(result);
    `,
  type: METHOD_TYPES.code,
  meta: {
    cgi: 'publishCount',
    tpl: 'list.publishCount'
  }
});
const getUnpublishedCountCode = () => `
  async () => {
    const listParams = {
       filter:source.unpublishedFilter,
    }
    const result = await source.$requests.unpublishedCount({query: listParams})
     if (result.body.code === 0) {
      source.unpublishedCount = result.body.data.total
    } else {
      ${getTipsCode()}
    }
    return result
  }
 `;
export const generateUnpublishedCountMethod = options => ({
  id: 'unpublishedCount',
  title: '获取未发布总数',
  code: getUnpublishedCountCode(),
  autoCatch: true,
  loading: true,
  debugCode: `
    const result = await invokeCurrentMethod();console.log(result);
    `,
  type: METHOD_TYPES.code,
  meta: {
    cgi: 'unpublishedCount',
    tpl: 'list.unpublishedCount'
  }
});
const getProdCountCode = () => `
  async () => {
    const listParams = {
       filter:source.prodFilter,
    }
    const result = await source.$requests.prodCount({query: listParams})
     if (result.body.code === 0) {
      source.prodCount = result.body.data.total
    } else {
      ${getTipsCode()}
    }
    return result
  }
 `;
export const generateProdCountMethod = options => ({
  id: 'prodCount',
  title: '获取正式表总数',
  code: getProdCountCode(),
  autoCatch: true,
  loading: true,
  debugCode: `
    const result = await invokeCurrentMethod();console.log(result);
    `,
  type: METHOD_TYPES.code,
  meta: {
    cgi: 'prodCount',
    tpl: 'list.prodCount'
  }
});
//# sourceMappingURL=prodList.js.map
